import { orderBy } from "natural-orderby";
export function sortEntitiesByNaturalName(entities) {
    return orderBy(entities, [(e) => e.name], "asc");
}
//# sourceMappingURL=sort-entities-by-natural-name.js.map